import { formatTimeRange } from '../lib/datetime';
import type { Session } from '../lib/queries';
import { TrackPill } from './TrackPill';

/**
 * What every session card says first: when, which track, what it is called and where. The agenda
 * and the personal schedule then add their own second half — speakers and a star on one, a
 * conflict warning on the other.
 *
 * It carries `pointer-events-none` because both cards are a single overlay link with controls
 * layered on top; nothing in here is meant to catch a tap of its own.
 */
export function SessionSummary({ session, timeZone }: { session: Session; timeZone: string }) {
  return (
    <div className="pointer-events-none">
      <div className="flex flex-wrap items-baseline justify-between gap-x-3 gap-y-1">
        <span className="text-subtitle font-medium text-ink-3 tabular-nums">
          {formatTimeRange(session.startsAt, session.endsAt, timeZone)}
        </span>
        {session.track && <TrackPill track={session.track} />}
      </div>

      <h3
        className={`font-display text-card-title mt-2 font-semibold ${
          session.isCancelled ? 'text-ink-3 line-through' : 'text-ink'
        }`}
      >
        {session.title}
      </h3>

      {session.roomName && (
        <p className="text-subtitle mt-1 text-ink-3">
          {session.roomName}
          {session.roomChanged && <span className="text-warn-text"> · room changed</span>}
        </p>
      )}
    </div>
  );
}
